<template>
  <v-app id="inspire">        
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'BlankRouterSection',
  components :{
  } 
}
</script>

